
import React, { useState, useEffect } from 'react';
import IllustrationThree from '@/components/IllustrationThree';
import { cn } from '@/lib/utils';

const Index = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={cn(
      "bg-white overflow-hidden transition-opacity duration-700 p-4 pt-8",
      isLoaded ? "opacity-100" : "opacity-0"
    )}>
      <div className="w-full max-w-4xl mx-auto animate-fade-up opacity-0" style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}>
        <div className="transition-all duration-500 transform">
          <IllustrationThree />
        </div>
      </div>
    </div>
  );
};

export default Index;
